import React from 'react';
import {FooterContainer} from './FooterContainer';

import type {FooterContainerProps} from './FooterContainer';

export type FooterNavProps = FooterContainerProps;

export const FooterNav = React.forwardRef<any, FooterNavProps>(({
    children, ...props
}, ref): React.ReactElement => (
    <FooterContainer
        {...props}
        component='nav'
        ref={ref}
    >
        {children}
    </FooterContainer>
));

FooterNav.displayName = 'FooterNav';
